var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button as MuiButton } from '@material-ui/core';
import { useStyles } from './styles';
import classNames from 'classnames';
function Button(_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, className = _a.className, props = __rest(_a, ["variant", "className"]);
    var classes = useStyles();
    /**
     * This is a temporary fix for the failing tests
     * which are using the dynamic data-testid from ActionButton
     * @TODO - add static data-testids, adjust all the failing tests & remove this
     */
    props['data-testid'] = props['data-testid'] || "action-button-" + ((_b = props.children) === null || _b === void 0 ? void 0 : _b.valueOf());
    var buttons = {
        primary: (_jsx(MuiButton, __assign({ variant: "contained", color: "primary", className: classNames(classes.primary, className) }, props), void 0)),
        secondary: (_jsx(MuiButton, __assign({ variant: "contained", color: "default", className: classNames(classes.secondary, className) }, props), void 0)),
        ghost: (_jsx(MuiButton, __assign({ variant: "outlined", color: "primary", className: classNames(classes.ghost, className) }, props), void 0)),
        text: _jsx(MuiButton, __assign({ variant: "text", className: classNames(classes.text, className) }, props), void 0),
        link: _jsx(MuiButton, __assign({ variant: "text", className: classNames(classes.link, className) }, props), void 0),
        dotted: (_jsx(MuiButton, __assign({ variant: "outlined", className: classNames(classes.dotted, className) }, props), void 0)),
    };
    return buttons[variant];
}
export default React.memo(Button);
